<template>
  <v-btn
    data-test-id="buttonSecondary"
    v-bind="$attrs"
    class="custom d-print-none"
    variant="outlined"
  >
    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-btn>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>

<style lang="scss" scoped>
.custom {
  background-color: #f7f7f7;
  border-color: $color-dark-16;
}
</style>
